export const filtrableLevels = ['read', 'write'];